import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import './DeleteMessageDialog.css';
import { onSubmitDeleteMsg } from '../handler/MessageHandler';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

function DeleteMessageDialog({ argsAll }) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const handleCloseConfirmModal = () => {
        argsAll.setOpenModalDeleteMsg({ isOpen: false, msg: null });
    };

    return (
        <Dialog
            open={argsAll.openModalDeleteMsg?.isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <div className="dialog-content">{tr('このメッセージを削除してよろしいでしょうか。')}</div>
            </DialogContent>
            <DialogActions className="dialog-action-delete">
                <Button
                    className="dialog-button-delete"
                    variant="contained"
                    onClick={async () => {
                        await onSubmitDeleteMsg(
                            argsAll.API,
                            argsAll.openModalDeleteMsg.msg,
                            argsAll.setStatusDeleteMsgList,
                            argsAll.statusDeleteMsgList,
                            argsAll.chatPostAllList,
                            argsAll.msgContentList,
                            argsAll.setChatPostUpdate,
                            argsAll.setOpenModalDeleteMsg,
                            argsAll?.ticketInfo,
                            argsAll?.selectThread
                        );
                    }
                    }
                >
                    {trI18n('COMBTN002')}
                </Button>
                <Button
                    className="dialog-action-cancel"
                    variant="contained"
                    onClick={() => handleCloseConfirmModal()}
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DeleteMessageDialog;
